import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const PlayBtn = ({ link }) => {
    return (
        <>
            {link ?
                <div className="rounded-circle  bg-light p-3" >
                    <a target="_blank" href={link ? link : null}>
                        <FontAwesomeIcon icon={faPlay} />
                    </a>
                </div>
                : null}
        </>
    );
};

export default PlayBtn;